<template>
  <v-dialog
    v-model="visibilidade"
    max-width="90%"
    persistent
  >
    <v-form ref="form">
      <v-card class="pa-4">
        <v-card-title>
          <h2 class="headline primary--text text-no-wrap">
            Importar Mapeamento
          </h2>
          <v-spacer />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="error"
                text
                @click="toogle"
                v-on="on"
              >
                <v-icon class="mr-2">
                  close
                </v-icon>
                Fechar
              </v-btn>
            </template>
            <span>Clique no botão para fechar a janela</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <mapeamento-list
                titulo="ESCOLHA UM MAPEAMENTO FINALIZADO"
                modo="IMPORTACAO"
                :mapeamento="mapeamento"
                @mapeamento="(value) => (mapeamento = value)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <app-title texto="ESCOLHA UMA OPÇÃO DE IMPORTAÇÃO" />
            </v-col>
            <v-col cols="12">
              <p class="subtitle-1 primary--text">
                Mapeamento Comportamental
              </p>
              <v-radio-group v-model="tipoImportacaoMapeamento">
                <v-radio
                  v-for="opcao in opcoesImportacao"
                  :key="opcao.id"
                  :value="opcao"
                >
                  <template v-slot:label>
                    <div>
                      <strong>{{ opcao.descricao }}:</strong>
                      {{ opcao.complemento }}
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <p class="subtitle-1 primary--text">
                Mapeamento Técnico
              </p>
              <p>
                Independente da opção de importação selecionada para o
                mapeamento comportamental, serão importados todos os dados
                consolidados do mapeamento técnico para a etapa de cadastro.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!mapeamento || !tipoImportacaoMapeamento"
            color="primary"
            @click="importar"
          >
            Importar
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="cancelar"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import MapeamentoList from '@/components/mapeamento/MapeamentoList';

export default {
  name: 'ImportacaoMapeamento',

  components: { AppTitle, MapeamentoList },

  props: {
    visibilidade: {
      type: Boolean,
      default: false,
      required: true,
    },
    toogle: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      mapeamento: null,
      tipoImportacaoMapeamento: null,
      opcoesImportacao: [
        {
          id: 'IMPORTAR_COMPORTAMENTAL_E_TECNICO',
          nome: 'Comportamental e Técnico',
          descricao: 'Importar Mapeamento Comportamental',
          complemento:
            'serão importados os 50 comportamentos consolidados do mapeamento selecionado'
            + ' para etapa de normalização',
        },
        {
          id: 'IMPORTAR_APENAS_TECNICO',
          nome: 'Técnico',
          descricao: 'Não Importar Mapeamento Comportamental',
          complemento: 'a(s) unidade(s) realizará(ão) novo cadastro comportamental',
        },
      ],
    };
  },

  methods: {
    importar() {
      const payload = {
        mapeamento: { ...this.mapeamento },
        tipoImportacaoMapeamento: { ...this.tipoImportacaoMapeamento },
        unidadesAtivas: this.mapeamento.unidades.filter((u) => u.ativa),
        unidadesInativas: this.mapeamento.unidades.filter((u) => !u.ativa),
      };
      this.mapeamento = null;
      this.tipoImportacaoMapeamento = null;
      this.$emit('import', payload);
    },
    cancelar() {
      this.mapeamento = null;
      this.tipoImportacaoMapeamento = null;
      this.toogle();
    },
  },
};
</script>
